import { sendError, sendEvent, sendInfo, sendTimeStamp } from './AnalyticsGoogleTag'

export const gaHelper = {
  addGAEvent: sendEvent,
  addError: sendError,
  addInfo: sendInfo,
  sendGATimeEvent: sendTimeStamp,
}
